import { DefaultService } from '@/services/DefaultService';

export default class AssProdutoPacoteKit extends DefaultService {

	constructor(http, router, env) {
		super(http, router, env);
	}

    find(id){
        return this._http.get(`${this._env}/sales/productbatch/${id}.json`, this._headers).then(res => {
            return res.body.content;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllByIdPacote (idPacote, situacao, column = 'descricao', order='desc', page = 0, limit = 50, ...param) {
        return this._http.get(`${this._env}/sales/packageproduct/getall/package/${idPacote}.json?situacao=${situacao}&order=${order}&column=${column}&page=${page}&limit=${limit}&param=${param}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    listAllByProductNaoAss (idProduto, column = 'descricao', order = 'asc', page = 0, limit = 50) {
        return this._http.get(`${this._env}/sales/product/listAllByProductNaoAss.json?order=${order}&column=${column}&page=${page}&limit=${limit}&idproduto=${idProduto}`, this._headers).then(res => {
            return res.body.content;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    updateSituacao(pacoteProduto) {
        return this._http.post(`${this._env}/sales/packageproduct/updatesituacao`, pacoteProduto, this._headers).then(res => {
          return res.body;
        }, err => {
          this.verifyError(err);
          throw err;
        });
    }
    
    save(lote) {
        return this._http.post(`${this._env}/sales/productbatch`, lote, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}